export const GB_FEATURES = {
  EXP_ALT_FOLLOW_BREEDER_CTA: 'exp_alt_follow_breeder_cta',
  EXP_SEARCH_SUMMARY: 'exp_search_summary',
  EXP_CHECKOUT_IMPROVEMENTS: 'exp_checkout_improvements'
};
